import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class ActivatorModel extends Model 
{
	@attr name;
	@attr('boolean') shouldCreateStartRecord;
	@attr('boolean') shouldCreateFinishRecord;
	@attr('boolean') shouldCreateFinishRecordOff;
	@attr('boolean') shouldCreateFinishPlungerRecord;
	@attr('boolean') shouldCreateFinishBibRecord;
	@attr('boolean') shouldCreateIntermediateTimingRecord;
	
	@belongsTo('event',{inverse: null, async: true}) EventId;
	@attr IntermediateTimingPointId;
}